import { createContext } from "react";

const ImageContext = createContext();

export default ImageContext